import { useMemo } from 'react';
import { BasicJSONSchema } from '@types';
import { getSchemaObject } from '@utils';

export const useSchemaObject = (schema: BasicJSONSchema | null) => {
    return useMemo(() => getSchemaObject(schema), [schema]);
};
